import { composeReducers } from 'common/util/composeReducers';
import { ACTIONS } from 'workflow/actions/viewer';

function loadWorkflowViewer(state, action) {
    if (!action || action.type !== ACTIONS.WORKFLOW_LOAD_DOCUMENT) {
        return state;
    }

    return {
        ...state,
        workflowViewer: {
            ...state.workflowViewer,
            document: action.payload
        }
    };
}

function unloadWorkflowViewer(state, action) {
    if (!action || action.type !== ACTIONS.WORKFLOW_UNLOAD_DOCUMENT) {
        return state;
    }
    const newState = {
        ...state
    };
    delete newState.workflowViewer;
    return newState;
}

export default composeReducers(
    loadWorkflowViewer,
    unloadWorkflowViewer
);
